import { CurrentUserServiceMethods } from '@splunk/olly-services/lib/services/CurrentUser/CurrentUserStore';
import { EnabledFeature } from '../../../../common/util/FeatureFlags';
import { CapabilityValues } from '@splunk/olly-services/lib/services/CurrentUser/Capabilities';

const hasAnyCapability = (
    currentUser: CurrentUserServiceMethods,
    featureEnabled: EnabledFeature
): ((capabilities: CapabilityValues[]) => Promise<boolean>) => {
    return async (capabilities: CapabilityValues[]): Promise<boolean> => {
        if (featureEnabled('newRbacExperience')) {
            return currentUser.hasAnyCapabilities(capabilities);
        }
        return true;
    };
};

hasAnyCapability.$inject = ['currentUser', 'featureEnabled'];
export default hasAnyCapability;
